module.exports = __webpack_public_path__ + "static/pic09-cc1308c565e0586c926786e9a4e67bac.jpg";